<template>
  <div>
    <div class="breadcrumb-area pos-relative">
      <h1>Cập nhật kết quả công việc</h1>
      <div class="float-right">
        <button class="btn btn-light" @click="$router.push('/calendar')">Hủy bỏ</button>
        <button class="btn btn-success btn-primary ml-2" @click="onSubmit">Cập nhật</button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 row">
        <ValidationObserver ref="updateWork" class="d-block w-100">
          <form class="col-md-6" @submit.prevent="onSubmit">
            <ValidationProvider rules="required" vid="result" name="Kết quả">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-3 col-form-label"
                  >Kết quả <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2 v-model="submitData.statusCat" :options="listResult" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="merchantName" name="Thời gian hoàn thành">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-3 col-form-label">
                  Thời gian hoàn thành <span style="color: red">*</span>
                </label>
                <div class="col-sm-7">
                  <DateTimePicker
                    v-model="submitData.timeFinish"
                    :config="optionsDatePicker"
                  ></DateTimePicker>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <div class="form-group row d-flex">
              <label for="" class="col-sm-3 col-form-label">Ghi chú</label>
              <div class="col-sm-7">
                <b-form-input type="text" v-model="submitData.result"></b-form-input>
              </div>
            </div>

            <div class="form-group row img-list mr-0 ml-0 d-flex">
              <UploadMultiple
                @syncFile="syncFile"
                :lsData="fileUploads"
                maxFil="100"
                uniqueKey="images"
                title="Ảnh"
                titleTag="h1"
                titleClass="form-inner-heading"
              />
            </div>
            <div v-if="fileCheckin" class="form-group row img-list mr-0 ml-0 d-flex">
              <UploadMultiple
                :lsData="fileCheckin"
                :canUpload="false"
                uniqueKey="images"
                title="Ảnh checkin"
                titleTag="h1"
                titleClass="form-inner-heading"
              />
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import moment from 'moment'
  import { CommonService } from '@/services/common.service'
  import { CalendarService } from '@/services/calendar.service'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import { v4 as uuidv4 } from 'uuid'
  import UploadMultiple from '@/components/UploadMultiple.vue'

  export default {
    components: { UploadMultiple },
    data() {
      return {
        Config,
        submitData: {
          urlImage: [],
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dateRange: {
          startDate: null,
          endDate: null,
        },
        showLoading: false,
        optionsDatePicker: {
          format: 'DD-MM-YYYY HH:mm',
          useCurrent: true,
        },
        fileUploads: [],
        fileCheckin: [],
      }
    },

    async created() {
      await this.fetchDetailCalendar()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        allConfig: 'common/allConfig',
      }),
      listResult() {
        return (
          this.allConfig.purposes
            .find(s => s.code === this.submitData.cat)
            ?.purposesStatus?.map(item => ({ id: item.code, text: item.name })) ?? []
        )
      },
    },

    methods: {
      async fetchDetailCalendar() {
        try {
          const { data } = await CalendarService.getById({ id: this.$route.params.id })
          this.submitData = data
          this.submitData.cat = data.leadAction ?? data.cat
          this.fileUploads = data.urlImage.map(s => ({ url: s, id: uuidv4() }))
          this.fileCheckin = data.checkinImage
        } catch (error) {
          console.log(error)
        }
      },

      async onSubmit() {
        const isSuccess = await this.$refs.updateWork.validate()
        if (!isSuccess) {
          return
        }
        try {
          this.showLoading = true
          let data = {}
          const files = await Promise.all(this.fileUploads.map(s => this.sendFile(s)))
          if (this.submitData.purposeType === 'LEAD') {
            data = await CalendarService.updateWorkResultLead({
              wkcldrId: this.$route.params.id,
              note: this.submitData.result,
              result: this.submitData.statusCat,
              exeDate: moment(this.submitData.timeFinish, this.optionsDatePicker.format).valueOf(),
              actionImgs: files.map(s => s.urlFile),
            })
          } else {
            data = await CalendarService.updateWorkResult({
              id: this.$route.params.id,
              outcome: 5,
              result: this.submitData.result,
              statusCat: this.submitData.statusCat,
              timeFinish: moment(
                this.submitData.timeFinish,
                this.optionsDatePicker.format
              ).toISOString(),
              urlImage: files.map(s => s.urlFile),
              checkinImage: this.fileCheckin,
            })
          }
          if (data.success) {
            this.showSuccessMx('Cập nhật công việc thành công').then(s =>
              this.$router.push(`/calendar/detail?id=${this.$route.params.id}`)
            )
          } else {
            this.showFailMx(data.message)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
      syncFile(files) {
        this.fileUploads = files
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          const data = await CommonService.uploadImg(formData)
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },
    },
  }
</script>
<style scoped>
  .pos-relative {
    width: 100%;
  }
</style>
